<div class="login-page">

  <!-- HEADER -->
  <div class="row">
    <div class="col-12">
      <div class="header">
        <div class="main_header">
          <img class="logo-imgs" src="assets/svg/BA Logo with Tagline Standard.svg" alt="Blue Pulse" />
        </div>
      </div>
    </div>
  </div>

  <!-- BODY -->
  <div class="row login-bg">

    <!-- LEFT CONTENT (same as login) -->
    <div class="col-lg-6 col-md-12 login-left-content">
      <label class="login-title">
        Built for Modern Workforce Management
      </label>
      <p class="login-subtitle">
        Get visibility into working hours, evaluate performance, and gain actionable insights to improve productivity.
      </p>
    </div>

    <!-- FORGOT PASSWORD CARD -->
    <div class="col-lg-6 col-md-12 d-flex justify-content-center">
      <mat-card class="admin_login_matcard">

        <label class="secon_admin_login_header_name">
          Forgot Password
        </label>
        <p class="subtitle">
          Enter your bluealtair email to receive a password reset link.
        </p>
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendResetLink()">

          <mat-form-field appearance="outline" class="full-width input-field">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" />

            <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('required')">
              Email is required
            </mat-error>

            <mat-error *ngIf=" forgotPasswordForm.get('email')?.hasError('email') &&
    !forgotPasswordForm.get('email')?.hasError('required')">
              Enter a valid email
            </mat-error>
            <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('errorMessage')">
              {{ forgotPasswordForm.get('email')?.errors?.errorMessage }}
            </mat-error>
          </mat-form-field>

          <div class="login-btn-wrapper">
            <button mat-raised-button class="secondary-login-in-button" type="submit" [disabled]="isSubmitting">
              {{ isSubmitting ? 'Sending...' : 'Send Link' }}
            </button>
          </div>

          <div class="forgotPassword_name">
            <button type="button" class="forgotPassword" (click)="login()">
              Back to Login
            </button>
          </div>

        </form>

      </mat-card>
    </div>

  </div>
</div>

<app-spinner></app-spinner>
